import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Params} from '@angular/router';

import { ZytdItem } from '../zytd/zytd-item';
import { ZytdItemEntities } from '../zytd/zytd-item-entity';
import { ZytdItemDetail } from './zytd-item-detail';
import { zytdDetailEntities } from './zytd-item-entity';
import { DOCUMENT } from '@angular/platform-browser';


@Component({
  selector: 'app-zytd-item-detail',
  templateUrl: './zytd-item-detail.component.html',
  styleUrls: ['./zytd-item-detail.component.css']
})

export class ZytdItemDetailComponent implements OnInit {
  itemId: any = -1;
  urlCur: string = "";
  zytdItems = ZytdItemEntities;
  selectedZytdItem: ZytdItem;
  zytdItemDetails = zytdDetailEntities;
  selecttedAytdItemDetailEntity: ZytdItemDetail;

  constructor(private activatedRout: ActivatedRoute, @Inject(DOCUMENT) document: any ) {
  this.urlCur = document.location.href;
}
/*
  constructor(public route: ActivatedRoute) {
      this.route.queryParams.subscribe((data) => {
        // console.log(data);
        this.id = data ;
        if ( this.id >= 0 && this.id < this.zytdItemDetails.length ) {
          this.selecttedAytdItemDetailEntity = this.zytdItemDetails[this.id - 1];
        } else {
          this.selecttedAytdItemDetailEntity = null ;
        }
    });
  }*/

  ngOnInit() {
    this.itemId = this.activatedRout.snapshot.params['id'] ;
    if ( this.itemId >= 0 && this.itemId <= this.zytdItemDetails.length ) {
      this.selecttedAytdItemDetailEntity = this.zytdItemDetails[this.itemId - 1];
      this.selectedZytdItem = this.zytdItems[this.itemId - 1];
    } else {
      this.selecttedAytdItemDetailEntity = null ;
      this.selectedZytdItem = null;
    }
  }

}
